// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fL6p","content":"styles_content__rMdot","tableWrap":"styles_tableWrap__pIYSV"};